module.exports = __webpack_public_path__ + "mainassets/img/tile1h.32767973.jpg";